import FadeIn from "react-fade-in";
import { useNotificationsSelector } from "../../hooks/useAppSelector";
import HeaderLoadingIcon from "../common/HeaderLoadingIcon";
import NotificationGroupIndicator from "./NotificationGroupIndicator";
import "./styles.less";
import { Box } from "@material-ui/core";
import { useAutoreloadNotifications } from "./useAutoreloadNotifications";
import DirectNotificationIcon from "./DirectNotificationIcon";
import { openNotifications } from "screens/Root/actions/notificationsActions";
import { useDispatch } from "react-redux";
const refreshInterval = 60 * 1000;
const NotificationIcons = ({ isTaskListVisible, }) => {
    const dispatch = useDispatch();
    const { notifications, directNotifications, initialized } = useNotificationsSelector();
    useAutoreloadNotifications(refreshInterval);
    const handleClick = () => dispatch(openNotifications());
    const sortedDirectNotifications = [...directNotifications].sort((a, b) => a.order > b.order ? 1 : -1);
    return (<>
      {!initialized ? (<HeaderLoadingIcon />) : (<Box data-identification="notification-icons-container" className="NotificationIcon-container">
          <FadeIn className="NotificationIcon-container">
            {sortedDirectNotifications.map((directNotification) => (<DirectNotificationIcon notification={directNotification}/>))}
          </FadeIn>

          {(isTaskListVisible || sortedDirectNotifications.length !== 0) &&
                notifications.length !== 0 && <div className="divider"></div>}
          <FadeIn className="NotificationIcon-container">
            {notifications.map((group) => (<NotificationGroupIndicator key={group.id} group={group} onClick={handleClick}/>))}
          </FadeIn>
        </Box>)}
    </>);
};
export default NotificationIcons;
